import { lazy } from 'react'
import { ROUTE_PATHS } from 'utils/constants/index'

const Game = lazy(() => import('pages/game/index'))
const ReplayGame = lazy(() => import('pages/replayGame/index'))
const ErrorPage = lazy(() => import('pages/error/index'))
const routesList = [
  {
    path: ROUTE_PATHS.error,
    component: ErrorPage,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.game,
    component: Game,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  },
  {
    path: ROUTE_PATHS.replay,
    component: ReplayGame,
    isPrivate: false,
    isHeader: true,
    isFooter: false
  }
]

export default routesList
